import { Slide, SlideProps, useTheme } from '@mui/material';
import * as React from 'react';
import { FC } from 'react';

interface AlertSliderProps extends SlideProps {
  onClose: (e: React.SyntheticEvent<Element, Event>) => void;
}

const AlertSlider: FC<React.PropsWithChildren<AlertSliderProps>> = props => {
  const { onClose, children } = props;
  const [closed, setClosed] = React.useState(false);
  const theme = useTheme();

  const handleClose = React.useCallback(
    (e: React.SyntheticEvent<Element, Event>) => {
      setClosed(true);

      if (onClose) {
        setTimeout(() => {
          onClose(e);
        }, theme.transitions.duration.leavingScreen);
      }
    },
    [onClose, theme.transitions.duration.leavingScreen],
  );

  const child = React.Children.only(children);
  const clonedChild = React.cloneElement(child, { onClose: handleClose });

  return (
    <Slide
      in={!closed}
      direction='down'
      unmountOnExit
      style={{ marginBottom: theme.spacing(1) }}>
      {clonedChild}
    </Slide>
  );
};

export default AlertSlider;
